<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" :form="form">
          <!-- 筛选的条件-->
          <a-row id="solo">
            <a-col :span="24">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单类型 :">
                <a-radio-group v-model="queryParam.typeName" button-style="solid" @change="getList(1)">
                  <a-radio-button :value="type.orderTypeId" v-for="type in orderTypeArr" :key="type.orderTypeId">
                    {{ type.typeName }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20" class="mt-10">
            <a-col :xl="8" :xxl="6">
              <a-form-item label="订单信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input :allowClear="true" v-model.trim="queryParam.orderSearch" placeholder="订单号/原始单号" />
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="客户信息">
                <a-input :allowClear="true" v-model.trim="queryParam.clientSearch" placeholder="客户姓名/电话" />
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="下单时间">
                <a-range-picker
                  style="width: 100%"
                  :allowClear="true"
                  format="YYYY-MM-DD"
                  @change="onChangerangepicker"
                  v-decorator="[
                    'createTime',
                    {
                      initialValue: defaultTime,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="企业名称">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseName"
                  :allowClear="true"
                  style="width: 100%"
                >
                  <a-select-option v-for="type in enterpriseArr" :value="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="订单负责人">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.orderPrincipal"
                  :allowClear="true"
                  style="width: 100%"
                >
                  <a-select-option v-for="type in orderPrincipalArr" :value="type.userName" :key="type.userId"
                    >{{ type.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :xxl="6">
              <a-form-item label="下单状态">
                <a-select v-model="queryParam.underOrderType" :allowClear="true">
                  <a-select-option value="0" title="自主下单"> 自主下单 </a-select-option>
                  <a-select-option value="1" title="系统派单"> 系统派单 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="24" :xxl="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="getList(1)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <!-- 表格内容-->
      <a-table
        :columns="columns"
        :rowClassName="setRowbg"
        :data-source="list"
        bordered
        :scroll="{ x: 1300 }"
        :pagination="false"
        :customRow="rowClick"
        size="middle"
      >
        <!-- 操作插槽 -->
        <span slot="action" slot-scope="text, record">
          <a-tag color="cyan" @click="editorder(record)">编辑 </a-tag>
          <a-tag color="pink" @click="distribute(record)">派单 </a-tag>
        </span>
        <!-- 订单编号 -->
        <span slot="orderNo" slot-scope="text, record">
          <div class="blue">
            {{ record.orderNo }}
            <a title="复制客户信息"><a-icon type="copy" class="copy" @click="copy(record)" /></a>
          </div>
        </span>
      </a-table>
      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList1"
        :showTotal="(total) => `总共 ${total} 条`"
        style="text-align: right; margin-top: 20px"
      />
    </a-card>
    <!-- 订单的付款方式为客户付款，则给出当前该弹框提示 -->
    <a-modal title="该订单为客户付款,请确定是否继续派单?" :width="400" :visible="showpaidan" :closable="false">
      <div style="color: red">请核实本单师傅结算金额是否正确!</div>
      <template slot="footer">
        <a-button @click="showpaidan = false">取消</a-button>
        <a-button type="primary" @click="continueOrder">继续派单</a-button>
      </template>
    </a-modal>
    <leaflets-distribute-model ref="leaflets" @update="getList(1)"></leaflets-distribute-model>
    <edit-order-model ref="editordermodel" @ok="query()"></edit-order-model>
  </div>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getEnterprise, getOrderType, getOrderPrincipal } from '@/api/order/common'
import { getBackOrderList, getorderInfo } from '@/api/order/orderList'

import moment from 'moment'
export default {
  components: {
    // 注册弹框组件
    editOrderModel: () => import('./modules/editOrderModel'),
    leafletsDistributeModel: () => import('./modules/leafletsDistributeModel'),
  },
  data() {
    return {
      form: this.$form.createForm(this),
      orderTypeArr: [], // 订单类型
      enterpriseArr: [], // 企业列表
      orderPrincipalArr: [], // 订单负责人
      // 派单弹窗
      showpaidan: false,
      paidanOrderId: undefined,
      // 查询参数
      queryParam: {
        typeName: '',
        orderSearch: '',
        clientSearch: '',
        enterpriseName: '',
        orderPrincipal: '',
        underOrderType: '',
        orderTime: '',
        timeStart: '',
        timeEnd: '',
        pageNum: '1',
        pageSize: '10',
      },
      list: [], // 列表数据
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '操作栏',
          // width: '270px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          scopedSlots: { customRender: 'orderNo' },
          align: 'center',
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },

        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          scopedSlots: { customRender: 'enterpriseName' },
          align: 'center',
        },

        {
          title: '客户姓名',
          dataIndex: 'clientName',
          scopedSlots: { customRender: 'clientName' },
          align: 'center',
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone',
          scopedSlots: { customRender: 'clientPhone' },
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',
          // header-align:"center",
          scopedSlots: { customRender: 'clientAddress' },
        },
        {
          title: '付款方式',
          dataIndex: 'payType',
          align: 'center',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
      ],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      tableCurrRowId: '',
    }
  },
  mounted() {
    // 获取订单类型
    getOrderType('SMART_SWITCH').then((res) => {
      if (res.code === 0) {
        res.rows.unshift({
          typeName: '全部',
          orderTypeId: '',
        })
        this.orderTypeArr = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    // 获取企业名称 // isAuthority 1 做数据隔离
    getEnterprise({ isAuthority: 1 }).then((res) => {
      if (res.code === 0) {
        this.enterpriseArr = res.data
      } else {
        this.$message.error(res.msg)
      }
    })
    // 获取订单负责人
    getOrderPrincipal().then((res) => {
      this.orderPrincipalArr = res
    })
    this.getList(1)
  },
  methods: {
    // 企业搜索功能
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },

    // 2、下单时间
    onChangerangepicker(date, dateString) {
      console.log(dateString)
      this.queryParam.timeStart = dateString[0]
      this.queryParam.timeEnd = dateString[1]
    },
    // 3、获取订单列表
    getList(page) {
      if (page == 1) {
        this.queryParam.pageNum = 1
        this.current = 1
      }
      getBackOrderList(this.queryParam).then((res) => {
        this.list = res.rows
        this.total = res.total
      })
    },
    // 4、清空查询条件
    empty() {
      this.queryParam = {
        typeName: '',
        orderSearch: '',
        clientSearch: '',
        enterpriseName: '',
        orderPrincipal: '',
        underOrderType: '',
        orderTime: '',
        timeStart: '',
        timeEnd: '',
      }
      this.form.setFieldsValue({
        createTime: [],
      })
    },
    // 复制
    copy(val) {
      const url =
        `订单号:` +
        val.orderNo +
        '\n' +
        `客户姓名:` +
        val.clientName +
        '\n' +
        `客户联系方式:` +
        val.clientPhone +
        '\n' +
        `客户地址:` +
        val.clientAddress
      const oInput = document.createElement('textArea')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message.success('复制成功')
      oInput.remove()
    },
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },
    getdataList1(value) {
      this.current = value
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      this.getList()
    },
    // // 订单详情
    // editorder(record, type) {
    //   this.$router.push({
    //     path: '/order/qyOrderDetail',
    //     query: {
    //       orderId: record.orderId,
    //       type
    //     }
    //   })
    // },
    // 派单
    distribute(record) {
      if (record.payType == '客户付款') {
        this.showpaidan = true
        this.paidanOrderId = record.orderId
      } else {
        getorderInfo({ orderId: record.orderId }).then((res) => {
          if (res.code === 0) {
            this.$refs.leaflets.showleaflets(res.data)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 派单弹窗里面的继续派单按钮
    continueOrder() {
      getorderInfo({ orderId: this.paidanOrderId }).then((res) => {
        if (res.code === 0) {
          this.showpaidan = false
          this.$refs.leaflets.showleaflets(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 编辑
    editorder(record) {
      this.$nextTick(() => {
        this.$refs.editordermodel.showeditOrder(record.orderId, '', 1, record.orderSubStatusAll, record.orderStatus)
      })
    },
    // 设置每行的颜色
    setRowbg(record) {
      return record.id === this.tableCurrRowId ? 'bg-pink' : null
    },
    // 点击每一行添加变量
    rowClick(record) {
      return {
        on: {
          click: () => {
            // 点击改行时要做的事情
            this.tableCurrRowId = this.tableCurrRowId == record.id ? '' : record.id
          },
        },
      }
    },
  },
}
</script>

<style scoped>
/deep/.table-page-search-wrapper .ant-form-inline .ant-form-item .ant-form-item-control-wrapper {
  overflow: hidden !important;
}
/deep/ #solo .ant-form-item {
  margin-bottom: 14px !important;
}
/deep/ #solo .ant-radio-button-wrapper {
  height: 28px !important;
  line-height: 26px !important;
  padding: 0 12px !important;
}
/deep/ .clickRowStyle {
  background: #ffbcb7;
}
/deep/ .clickRowStyle3 {
  background: #f9ff9f;
}
/deep/ .clickRowStyle4 {
  background: #ffa07a;
}
/deep/ .ant-calendar-picker {
  width: 276px;
}
/deep/ .notshow {
  display: none;
}
/deep/ .ant-table th {
  white-space: nowrap;
}

/*</a-form-item>*/
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
/deep/ p {
  margin-top: 0;
  margin-bottom: 0em;
}
/deep/ .ant-pagination-options-quick-jumper input {
  width: 80px;
}
/deep/ .ant-radio-button-wrapper:not(:first-child)::before {
  background-color: #fff;
}
/deep/ .ant-radio-button-wrapper {
  border: none;
  border-radius: 4px;
}
/deep/ .bg-pink {
  background-color: rgb(255, 212, 147);
}
.tag {
  font-size: 14px;
  height: 24px;
  line-height: 24px;
}
.blue {
  font-size: 16px;
}
</style>
